import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 3-5 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 3 5 5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FilterX";
const FilterX = memo(themed(Icon));
export {
  FilterX
};
//# sourceMappingURL=filter-x.js.map
